import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.VIRTUAL_MOTHERSHIP_QTY,
  displayName: "Xray",
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "jpd-icon",
    title: "E+ Platform",
    valueTransformer: (value) => value,
    valueTransformerSH: (value) => {
      return { display: value !== "N/A", value: value };
    },
    tooltip: {
      text: "JFrog Platform that includes <br> all the platform capabilities.",
      link: "https://jfrog.com/help/r/get-started-with-the-jfrog-platform/jfrog-platform-overview",
    },
  },
};

export default entitlement;
